import { styled, SxProps } from '@mui/material'
import { CreateTypes, Options } from 'canvas-confetti'
import { forwardRef, useCallback, useImperativeHandle, useRef } from 'react'
import ReactCanvasConfetti from 'react-canvas-confetti'

export type CanvasConfettiProps = {
  sx?: SxProps
}

export type CanvasConfettiRef = {
  start: () => void
}

export const CanvasConfetti = forwardRef<
  CanvasConfettiRef,
  CanvasConfettiProps
>(({ sx }, ref) => {
  const animationInstanceRef = useRef<CreateTypes | null>(null)

  useImperativeHandle(ref, () => ({
    start() {
      setTimeout(nextTickAnimation, 1000)
    },
  }))

  const nextTickAnimation = useCallback(() => {
    if (animationInstanceRef.current) {
      animationInstanceRef.current(getAnimationSettings(0.1, 0.3))
      animationInstanceRef.current(getAnimationSettings(0.7, 0.9))
    }
  }, [])

  return (
    <ReactCanvasConfettiStyled
      sx={sx}
      refConfetti={ref => (animationInstanceRef.current = ref)}
    />
  )
})

const ReactCanvasConfettiStyled = styled(ReactCanvasConfetti)(() => ({
  position: 'absolute',
  pointerEvents: 'none',
  outline: 'none',
  width: '100%',
  height: '100%',
  top: 0,
  left: 0,
}))

function getAnimationSettings(originXA: number, originXB: number): Options {
  return {
    startVelocity: 30,
    spread: 360,
    ticks: 60,
    zIndex: 0,
    particleCount: 150,
    origin: {
      x: Math.random() * (originXB - originXA) + originXA,
      y: Math.random() - 0.2,
    },
  }
}
